module.exports = __webpack_public_path__ + "img/20.aaca0552.jpg";